import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ onCreateProject }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-12 text-center">
      <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
        <Icon name="MessageSquare" size={32} className="text-muted-foreground" />
      </div>
      
      <h3 className="text-xl font-heading text-foreground mb-2">No Feedback Yet</h3>
      <p className="text-muted-foreground mb-6 max-w-md mx-auto">
        Start sharing your designs with clients to receive feedback and approvals. 
        Create your first project to get started.
      </p>
      
      <Button
        variant="default"
        iconName="Plus"
        iconPosition="left"
        onClick={onCreateProject}
      >
        Create First Project
      </Button>
    </div>
  );
};

export default EmptyState;